import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import api from "../../api/axios";
import { IGenericApiState } from "../../types/api";

const initialState: IGenericApiState<null> = {
  data: null,
  status: "idle",
  error: "",
};

export const downloadReportAsync = createAsyncThunk(
  "downloadReport",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await api.get(`reports-history/${id}/download`, {
        responseType: "blob",
      });

      const disposition = response.headers["content-disposition"] ?? "";
      const match = /filename="?([^"]+)"?/.exec(disposition);
      const filename = match?.[1] ?? `report-${id}`;

      const objectUrl = URL.createObjectURL(response.data as Blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);

      return null;
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  },
);

export const downloadReportSlice = createSlice({
  name: "downloadReport",
  initialState,
  reducers: {
    downloadReportReset: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = "";
    },
  },
  extraReducers: (builders) => {
    builders
      .addCase(downloadReportAsync.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(downloadReportAsync.fulfilled, (state) => {
        state.status = "success";
      })
      .addCase(downloadReportAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { downloadReportReset } = downloadReportSlice.actions;

export default downloadReportSlice.reducer;
